// src/context/AfiliadoContext.jsx
import React, { createContext, useContext, useState } from 'react';
import { db } from '../firebase';
import { collection, query, where, getDocs, limit } from 'firebase/firestore';

const AfiliadoContext = createContext(null);

export const AfiliadoProvider = ({ children }) => {
  const [afiliado, setAfiliado]           = useState(null);
  const [vistaAfiliado, setVistaAfiliado] = useState(false);

  const login = async (codigo) => {
    if (!codigo?.trim()) return { ok: false, error: 'Ingresa un código.' };
    
    const codigoLimpio = codigo.trim().toUpperCase();

    try {
      // Se busca dentro del mapa comercial usando 'comercial.codigo_descuento'
      const q = query(
        collection(db, 'trabajadores'),
        where('comercial.codigo_descuento', '==', codigoLimpio),
        limit(1)
      );

      const snap = await getDocs(q);

      if (snap.empty) {
        return { ok: false, error: 'Código no encontrado.' };
      }

      const docSnapshot = snap.docs[0];
      const datos = docSnapshot.data();

      // Busca el nombre tanto si está dentro de 'comercial' como en la raíz del documento
      const nombre = 
        datos.comercial?.nombre || 
        datos.comercial?.name || 
        datos.nombre || 
        datos.name || 
        'Afiliado';

      const infoAfiliado = {
        id: docSnapshot.id,
        nombre,
        codigoDescuento: codigoLimpio,
        ...datos, // Conserva toda la data por si necesitas otros campos como comisiones o teléfono
      };

      setAfiliado(infoAfiliado);
      setVistaAfiliado(true);
      return { ok: true, nombre, data: infoAfiliado };
    } catch (error) {
      console.error('Error al verificar afiliado:', error);
      return { ok: false, error: 'Error al verificar el código.' };
    }
  };

  const logout = () => {
    setAfiliado(null);
    setVistaAfiliado(false);
  };

  return (
    <AfiliadoContext.Provider value={{ afiliado, vistaAfiliado, setVistaAfiliado, login, logout }}>
      {children}
    </AfiliadoContext.Provider>
  );
};

export const useAfiliado = () => useContext(AfiliadoContext);